import type { BreadcrumbItem } from '@/components/organisms/WebHeader';
import React, { type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { GuestTopBar } from './GuestTopBar';

export interface GuestWebChromeProps {
  readonly children: ReactNode;
  readonly headerTitle: string;
  readonly breadcrumbs?: BreadcrumbItem[];
  readonly showBackButton?: boolean;
  readonly onBackPress?: () => void;
  readonly projectId?: string;
}

/**
 * Logged-out guest chrome: Bloom logo + language toggle + optional breadcrumbs.
 * Authenticated users never reach this (redirected in `GuestRouteGate`).
 */
export function GuestWebChrome({
  children,
  headerTitle,
  breadcrumbs,
  showBackButton = false,
  onBackPress,
  projectId,
}: Readonly<GuestWebChromeProps>) {
  return (
    <View style={styles.guestShell}>
      <GuestTopBar
        headerTitle={headerTitle}
        {...(breadcrumbs != null ? { breadcrumbs } : {})}
        showBackButton={showBackButton}
        {...(onBackPress != null ? { onBackPress } : {})}
        {...(projectId != null ? { projectId } : {})}
      />
      <View style={styles.guestBody}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  guestShell: {
    flex: 1,
    width: '100%',
    minWidth: 0,
    minHeight: 0,
  },
  guestBody: {
    flex: 1,
    width: '100%',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
  },
});
